import Cookies from "js-cookie";

export default function useCookie() {
  const setCookie = (key, data, options) => {
    Cookies.set(key, data, options);
  };

  const getCookie = (key) => {
    return Cookies.get(key);
  };

  const removeCookie = (key) => {
    Cookies.remove(key);
  };
  return {
    setCookie,
    getCookie,
    removeCookie,
  };
}
